function Logo(props) {
  return (
    <img
      width="200px"
      alt="Logo"
      src="/static/logo-white.png"
      {...props}
    />
  );
}

export default Logo;
